import { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';

// Tools teammates published into Run (approved rows in the shared published_tools
// table). They render embedded via /tools/:toolId and live in the "Team Tools"
// nav section. Empty array until loaded / when Supabase isn't configured.
export function usePublishedTools() {
  const [tools, setTools] = useState([]);

  useEffect(() => {
    if (!supabase) return;
    let alive = true;
    supabase
      .from('published_tools')
      .select('id, name, description, url, owner_name')
      .eq('app_key', 'run')
      .eq('status', 'published')
      .order('sort', { ascending: true })
      .order('name', { ascending: true })
      .then(({ data, error }) => {
        if (alive && !error && data) setTools(data);
      });
    return () => {
      alive = false;
    };
  }, []);

  return tools;
}
